import { COOKIE_NAME, PhiMode } from './constants.ts';
import { getCookie } from '../cookie/getCookie.ts';

/** Returns the current value of hide PHI */
export function getHidePhi(): PhiMode {
  return getCookie(COOKIE_NAME);
}